export const getAllGraphStepChildrenIds = (graph, stepId, array = [], exclude) => {
  const step = graph[stepId];
  if (step?.exit && !array.includes(step.exit) && exclude !== 'exit') {
    array.push(step.exit);
    getAllGraphStepChildrenIds(graph, step.exit, array);
  }
  if (step?.child && !array.includes(step.child) && exclude !== 'child') {
    array.push(step.child);
    getAllGraphStepChildrenIds(graph, step.child, array);
  }
  if (step?.branches && exclude !== 'branches') {
    for (let i = 0; i < step.branches.length; i++) {
      const branchStepId = step.branches[i];
      if (branchStepId && !array.includes(branchStepId)) {
        array.push(branchStepId);
        getAllGraphStepChildrenIds(graph, branchStepId, array);
      }
    }
  }
  return array;
};
